module.exports = __webpack_public_path__ + "img/service2_active.4ab99692.png";